import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private documentsList = new BehaviorSubject<any[]>([]);
  documents$ = this.documentsList.asObservable(); // Expose tasks as observable

  constructor(
    private localStorage: LocalStorageService
  ) {}

  setDocuments(newTasks: any[]) {
    this.documentsList.next(newTasks);
  }

}
